module.exports = __webpack_public_path__ + "static/media/event-services-img18.43794238.jpg";